import React from 'react';
import { To } from 'react-router-dom';

import * as S from './NavOption.styles';
import { FontWeightsType, Icon, Text } from '@nicheinc/campus-ds';

type NavOptionPropsType = {
	focused?: boolean;
	disabled?: boolean;
	text: string;
	textColor?: string;
	textWeight?: FontWeightsType;
	icon?: string;
	iconColor?: string;
	rightIcon?: string;
	onClick?: () => void;
	redirectTo?: string;
	setPopupMenuIsOpen?: (isOpen: boolean) => void;
};
function NavOption({
	focused,
	disabled,
	text,
	textColor,
	textWeight = 'regular',
	icon,
	iconColor,
	onClick,
	redirectTo,
	setPopupMenuIsOpen,
	...rest
}: NavOptionPropsType) {
	return (
		<S.OptionWrapper
			aria-hidden="true"
			role="button"
			tabIndex={0}
			onKeyDown={(e: any) => {
				if (e.key === 'Enter') onClick?.();
			}}
			onClick={(e: { preventDefault: () => any }) => {
				if (!!onClick) {
					e.preventDefault();
				}

				onClick && onClick();

				setPopupMenuIsOpen && setPopupMenuIsOpen(false);
			}}
			to={redirectTo as To}
			focused={focused}
			disabled={disabled}
			{...rest}
		>
			<S.NavOptions>
				<S.OptionDetails>
					{!!icon && (
						<Icon
							iconName={icon}
							color={iconColor || 'neutral.icon.default'}
							size="medium"
						/>
					)}

					<div className="text-wrapper">
						<Text
							size="small"
							color={textColor || 'system.text.default'}
							fontWeight={textWeight}
							lineHeight="regular"
						>
							{text}
						</Text>
					</div>
				</S.OptionDetails>
			</S.NavOptions>
		</S.OptionWrapper>
	);
}

export default NavOption;
